.fp-alert.-warning(data-test='giveaway-missing-answers')
  i.fp-icon.fp-glyph-warning.-color-warning.-s18
  .fp-vertical-spacing.-s-xs
    .fp-vertical-spacing--line
      span.fp-text.-paragraph {{ t('giveawayResults.missingAnswers', {count: missingAnswers.length}) }}
    .fp-vertical-spacing--line
      a.fp-link(@click='openMissingAnswersFormModal' data-test='open-modal') {{ t('giveawayResults.fillMissingAnswers') }}
